import PropTypes from 'prop-types';
import { Avatar, Box, Chip, IconButton, Stack, Typography } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { fDateTime } from '../../../utils/formatTime';

export default function ManageUserDialogHeader({ handleClose, onAvatarClick, profileName, showCloseButton = true, user }) {
  const userId = user?.user_id || 'N/A';
  const lastSeen = user?.last_seen_at ? fDateTime(user.last_seen_at) : 'N/A';

  return (
    <Box
      sx={{
        px: { xs: 2, md: 3 },
        py: 1.5,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
          <Avatar
            src={user?.image_url}
            alt={profileName}
            onClick={user?.image_url ? onAvatarClick : undefined}
            sx={{
              width: 58,
              height: 58,
              bgcolor: 'grey.700',
              cursor: user?.image_url ? 'pointer' : 'default',
              transition: 'transform 120ms ease',
              '&:hover': user?.image_url
                ? {
                    transform: 'scale(1.03)',
                  }
                : undefined,
            }}
          >
            {profileName.slice(0, 1)}
          </Avatar>

          <Box sx={{ minWidth: 0 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ flexWrap: 'wrap' }}>
              <Typography variant="h6" noWrap>
                {profileName}
              </Typography>
              <Chip size="small" label={`ID: ${userId}`} variant="outlined" />
            </Stack>

            <Stack direction="row" spacing={1} sx={{ mt: 0.5, flexWrap: 'wrap' }}>
              {user?.account_verification_status ? (
                <Chip size="small" label={user.account_verification_status} variant="outlined" />
              ) : null}
              <Typography variant="caption" color="text.secondary" sx={{ alignSelf: 'center' }}>
                Last seen: {lastSeen}
              </Typography>
            </Stack>
          </Box>
        </Stack>

        {showCloseButton ? (
          <IconButton onClick={handleClose} size="small" sx={{ color: 'text.secondary' }}>
            <GridCloseIcon />
          </IconButton>
        ) : null}
      </Stack>
    </Box>
  );
}

ManageUserDialogHeader.propTypes = {
  handleClose: PropTypes.func,
  onAvatarClick: PropTypes.func.isRequired,
  profileName: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool,
  user: PropTypes.object,
};
